import { ProtectedState } from "./components/ProtectedComponent/reducer";
import { AppState } from "./reducers";

export const protectedComponentStoreStateSelector = (
  state: AppState
): ProtectedState => {
  return state.protected;
};
